<template>
  <div>
    <van-popup
      v-model="isShowDetail"
      position="bottom"
      :style="{ height: '100%',background: '#f5f5f5' }"
    >
       <van-nav-bar fixed>
          <div slot="title">详细</div>
          <div slot="right" @click="close">关闭</div>
        </van-nav-bar>
        <div class="message-block" style="margin-top:52px">
          <div class="message-top clearfix">
            <div class="fl">
              <div class="message-info">
                <b class="my-name-size">{{studentObj.FullName}}</b>
              </div>
              <div class="message-info">曾用名：{{studentObj.OldName!==null?studentObj.OldName:'未设置'}}</div>
              <div class="message-info">性别：{{studentObj.Sex}}</div>
              <div class="message-info">入学年份：{{studentObj.EntranceTime}}</div>
            </div>
            <div class="fr">
              <img :src="studentObj.Icon" style="width:80px;height:100px;" />
            </div>
          </div>
          <div class="message-top">
              <div class="message-info">身份证号：{{studentObj.UserNumber === null || studentObj.UserNumber === "" ? '未设置' : studentObj.UserNumber}}</div>
              <div class="message-info">出生日期：{{studentObj.BirthDate}}</div>
              <div class="message-info">籍贯：{{studentObj.NativePlace!==null?studentObj.NativePlace:'未设置'}}</div>
              <div class="message-info">户籍地址：{{studentObj.Address!==null?studentObj.Address:'未设置'}}</div>
              <div class="message-info">现住址：{{studentObj.CurrAddress!==null?studentObj.CurrAddress:'未设置'}}</div>
              <div class="message-info">邮箱：{{studentObj.EmailAddress !== '' ? studentObj.EmailAddress : '未设置'}}</div>
          </div>
        </div>
       <div class="message-block ">
          <div class="message-info">父亲姓名：{{fatherObj.ParentsName}}</div>
          <div class="message-info">手机号：{{fatherObj.Phone}}</div>
          <div class="message-info">工作单位：{{fatherObj.Works}}</div>
          <div class="message-info">职务：{{fatherObj.Position}}</div>
          <div class="message-info">最高学历：{{fatherObj.Education}}</div>
          <div class="message-info">毕业学校：{{fatherObj.School}}</div>
        </div>
        <div class="message-block ">
          <div class="message-info">母亲姓名：{{motherObj.ParentsName}}</div>
          <div class="message-info">手机号：{{motherObj.Phone}}</div>
          <div class="message-info">工作单位：{{motherObj.Works}}</div>
          <div class="message-info">职务：{{motherObj.Position}}</div>
          <div class="message-info">最高学历：{{motherObj.Education}}</div>
          <div class="message-info">毕业学校：{{motherObj.School}}</div>
        </div>
    </van-popup>
  </div>
</template>
<script>
import xyapi from "@/common/api";
export default {
  name: "Details",
  props: {
    isShowDetail: Boolean,
    studenID: Number
  },
  data() {
    return {
      studentObj: {},
      fatherObj: {},
      motherObj: {}
    };
  },
  watch: {
    isShowDetail: {
      handler(val) {
        if (val) {
          this.getStudent();
          this.getParents();
        }
      },
      deep: true
    }
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {
    async getStudent() {
      this.xy.loading();
      let res = await xyapi.get( `${this.$store.state.apiPath}/api/HeadmasterManager/GetStudentByID`,
        {
          studentID: this.studenID
        }
      );
      this.xy.unloading();
      if (res.success) {
        this.studentObj = res.data;
        this.studentObj.Sex? (this.studentObj.Sex = "男"): (this.studentObj.Sex = "女");
        this.studentObj.BirthDate === "0001-01-01 00:00:00"? (this.studentObj.BirthDate = "未设置"):  (this.studentObj.BirthDate=this.xy.moment(this.studentObj.BirthDate).format('YYYY-MM-DD'));
        this.studentObj.EntranceTime === null ||this.studentObj.EntranceTime === 0? (this.studentObj.EntranceTime = "未设置"): (this.studentObj.EntranceTime = this.studentObj.EntranceTime);
        this.studentObj.Icon === ""? `${this.xyMApi}/image/yrykb.png`:this.xyMApi+this.studentObj.Icon + "?" + Math.random();
      }
    },
    async getParents() {
      this.xy.loading();
      let res = await xyapi.get( `${this.$store.state.apiPath}/api/HeadmasterManager/GetParents`,
        {
          studentID: this.studenID
        }
      );
      this.xy.unloading();
      if (res.success) {
        this.fatherObj = res.data.father;
        this.motherObj = res.data.mother;
      }
    },
    close() {
      this.$emit("listenToClose", false);
    }
  }
};
</script>
<style lang="less" scoped>
.message-block {
    background-color: #fff;
    border-width: 1px 0px;
    border-style: solid;
    border-color: #eee;
    margin-top: 20px;
    padding: 20px;
    font-size: 28px;
    .message-info {
      margin-bottom: 20px;
      color: #333;
    }
}

</style>
